import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";

export const createReturn = async (businessId, payload) => {
  try {
    let resp = await http.post(`${URL}/return/${businessId}/create`, payload);
    return resp;
  } catch (error) {
    console.error("Error:", error);
    errorHandler(error);
  }
};

export const getReturns = async (businessId, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(
      `${URL}/return/${businessId}/get-return?${queryString}`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const createPurchaseReturn = async (businessId, data) => {
  try {
    let resp = await http.post(
      `${URL}/return/${businessId}/purchase-create`,
      data
    );
    console.log("object created", resp);
    return resp;
  } catch (error) {
    console.log("failed to create purchase", error);
    errorHandler(error);
  }
};

export const getAllPurchaseReturnService = async (businessId, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(
      `${URL}/return/${businessId}/purchase-return?${queryString}`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
